import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import AirConditionServiceList from '@/views/AirConditionServiceList.vue';
import TasksList from '@/views/TasksList.vue';
import TenantList from '@/views/TenantList.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Home,
  },
  {
    path: '/technical-review/air-condition/list',
    component: AirConditionServiceList,
  },
  {
    path: '/task/list',
    component: TasksList,
  },
  {
    path: '/tenant/list',
    component: TenantList,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
